export const COURSES_OF_ACTION_LABEL = 'Response Plan';
